import { all, fork } from 'redux-saga/effects';
import {
  watchGetConversationSaga,
  watchCreateCommentOnapiSaga,
  watchCreateCommentOnWSSaga,
  watchUpdateCommentSaga,
  watchDeleteCommentSaga,
} from './sagas';
import { slice } from './slices';

export const conversationRootSaga = function* () {
  yield all([
    fork(watchGetConversationSaga),
    fork(watchCreateCommentOnapiSaga),
    fork(watchCreateCommentOnWSSaga),
    fork(watchUpdateCommentSaga),
    fork(watchDeleteCommentSaga),
  ]);
};

export const conversationReducer = slice.reducer;

export * from './actions';
export * from './types';
export * from './use-conversation-store';
